import ApiUrl from 'enum/api-url.enum';
import httpService from 'services/http/http.service';

function putDevicesRoom(data) {
  return httpService.put(ApiUrl.DEVICEFORPORTAL, data);
}

const obj = { putDevicesRoom };

export default obj;
